import { Backdrop, CircularProgress } from "@mui/material";

const Loading = ({ loading = false }: { loading: boolean }) => (
  <Backdrop
    sx={{
      color: "primary.contrastText",
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
    open={loading}
    transitionDuration={1000}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default Loading;
